import { forwardRef, useState } from "react";

import { TextField } from "../../atoms/text-field";
import type { PasswordFieldProps } from "./types";

export const PasswordField = forwardRef<React.ElementRef<typeof TextField>, PasswordFieldProps>(
  (props, ref) => {
    const [visible, setVisible] = useState(false);

    return (
      <TextField
        ref={ref}
        {...props}
        leadingIcon="Lock"
        trailingIcon={visible ? "Eye" : "EyeSlash"}
        onTrailingIconPress={() => setVisible((v) => !v)}
        trailingIconLabel={visible ? "Hide password" : "Show password"}
        secureTextEntry={!visible}
      />
    );
  },
);

PasswordField.displayName = "PasswordField";
